import { classes, convertStyle } from "../../../react/react"
import { IDateViewModel } from "../types"
import * as content from "./content"
import { TimelineComponentProps } from "./types"

/// <reference path="../../../react/react.ts" />

interface Props extends Pick<TimelineComponentProps, "vm" | "viewState"> {
    setWidth?: boolean
}

export function Dates({ vm, viewState: { currentItem }, setWidth }: Props) {

    const currentCroppingStyle = convertStyle(content.getDateCurrentCroppingStyle(vm, currentItem))

    const currentYearStyle = convertStyle(content.getCurrentYearStyle(vm))
    const getDateStyle = (item: IDateViewModel, index: number) => convertStyle(content.getDateStyle(vm, item, index))

    const placeholderWidth = 17
    const width = vm.fullWidth + vm.viewConfig.leftOffset

    const style = setWidth
        ? { width: width + "px " }
        : undefined

    return <div className="tl-dates" style={style}>

        {
            currentItem
                ? (<div className="current" style={currentCroppingStyle}></div>)
                : null
        }

        {

            vm.dates
                .filter(i => i.left >= 0)
                .map((i, index) =>

                    <div key={i.date.toISOString()}>

                        <div className={classes("date", i.cropyear && "cropyear")} style={{ top: 0, ...getDateStyle(i, index) }}>
                            {formatHeaderDate(i.date)}
                        </div>

                        <div className="tick" style={getDateStyle(i, index)}>
                        </div>

                    </div>

                )
        }

        <div className="tl-cropyear" style={currentYearStyle}>
        </div>

        {/* Placeholder to account for a verticall scrollbar displayed in the main componnent */}
        <div className="placeholder" style={{ position: "absolute", top: 0, bottom: 0, width: placeholderWidth, left: width }}></div>

    </div>


}

function formatHeaderDate(date: Date) {
    return date.toLocaleString(["en-GB"], { month: "short", year: "2-digit" })
}
